import React from 'react';
import PropTypes from 'prop-types';
import LedgerFilterForm from 'components/installation/siteFilterForm/ledgerFilterForm';

import { Button } from 'react-bootstrap';

const LedgerFilter = ({
  showFilter = false,
  filterToggle,
  applyFilter,
  getZones,
  siteFilters = false,
  listFilterData = null,
  invoiceFilters = false,
  paymentRequestFilter = false,
  zones = [],
  status = [],
  statusId,
  isRoleId,
}) => {
   //console.log('FILTER::LEDGER FILTER');
  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
            <Button onClick={filterToggle} className="close"></Button>
          </div>
          <div className="filter-body scrollbar-styling">
            {siteFilters && (
              <LedgerFilterForm
              applyFilter={(val) => applyFilter(val)}
              siteTypes={
                listFilterData !== null ? listFilterData.site_types : []
              }
              assignedAreas={
                listFilterData !== null ? listFilterData.assigned_areas : []
              }
              reportees={
                // listFilterData !== null ? listFilterData.reportees : []
                []
              }
              siteStatus={
                listFilterData !== null ? listFilterData.site_status : []
              }
            />
            )}

          </div>
        </div>
      )}
    </div>
  );
};

LedgerFilter.propTypes = {
  showFilter: PropTypes.bool,
  filterToggle: PropTypes.func,
  applyFilter: PropTypes.func,
  getZones: PropTypes.func,
  getAreas: PropTypes.func,
  
};

export default LedgerFilter;
